import script from "./IndicatorCard.vue?vue&type=script&setup=true&lang=js"
export * from "./IndicatorCard.vue?vue&type=script&setup=true&lang=js"

import "./IndicatorCard.vue?vue&type=style&index=0&id=6bacc49d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bacc49d"]])

export default __exports__